import React from 'react';
import CrmTimelineListPage from './components/CrmTimelineListPage';

export default function NotesPage() {
  return (
    <CrmTimelineListPage
      pageKey="notesPage"
      notesOnly
      showDealAmount
    />
  );
}
